const arrayRemoveIndex = (array: Array<any>, index: number) =>
  array.slice(0, index).concat(array.slice(index + 1));

export default arrayRemoveIndex;
